module.exports = __webpack_public_path__ + "img/eagleWingsLogo@2x.74119c6a.png";